import { RestHelper } from "../helpers/RestHelper";

export class DeclarationCostService {
  private _restHelper;

  constructor() {
    this._restHelper = new RestHelper();
  }

  async SaveCost(payload: any) {
    const url: string = "DeclarationCost/Save";
    let response = await this._restHelper.post(url, payload);
    return response;
  }

  async DeleteCost(payload: any) {
    const url: string = "DeclarationCost/Delete";
    let response = await this._restHelper.post(url, payload);
    return response;
  }

  async UploadCost(payload: any) {
    const url: string = "DeclarationCost/Upload";
    let response = await this._restHelper.postFile(url, payload);
    return response;
  }

  
  async DownloadCost(payload: any) {
    const url: string = "DeclarationCost/Download";
    let response = await this._restHelper.downloadFile(url, payload);
    return response;
  }
 
  async DownloadCostUrl(payload: any) {
    const url: string = "DeclarationCost/Download";
    let response = await this._restHelper.getUrl(url, payload);
    return response;
  }
  
  async GetEurRate(payload: any) {
    const url: string = "DeclarationCost/GetEurRate";
    let response = await this._restHelper.post(url, payload);
    return response;
  }
  
  
  async GetByDeclarationID(payload: any) {
    const url: string = "DeclarationCost/GetByDeclarationID";
    let response = await this._restHelper.post(url, payload);
    return response;
  }
 
}
